<template>
  <div class="cardioBg">
    <van-nav-bar
      title="我的档案"
      left-arrow
      ref="navBar"
      class="main-nav"
      @click-left="onClickLeft"
    />
    <div class="mainBg">
      <div class="mainContent">
        <div class="titBg">
          <img src="../../assets/images/family-archives/tit-left.png" alt="" />
          <div>基本信息</div>
          <img src="../../assets/images/family-archives/tit-right.png" alt="" />
        </div>

        <div class="basic margintop20">
          <div class="title">
            <div class="title-group">
              <img
                src="../../assets/images/family-archives/round.png"
                class="title-img"
              />
              <span class="p15" style="font-weight: 600">基本信息</span>
            </div>
            <div class="marginright8">
              <img src="../../assets/images/family-archives/pen.png" class="title-img" v-if="checkedEdit" @click="handeler" />
              <span class="p15" style="color: #FF8340" v-else @click="saveHandle" native-type="submit">完成</span >
            </div>
          </div>
					<van-form @submit="onSubmit">
						<van-field
							readonly
             	label="头像"
             	class="fristcell"
             	:value="headImg"
							input-align="right"
						>
							<template #input>
								<img :src="headImg" alt="" v-if="readOnly" class="maskLayer">
								<van-uploader :after-read="afterRead" v-else @oversize="onOversize" :max-size="10*1024*1024" accept="image/png, image/jpeg" >
									<van-image
										round
										:src="headImg"
									/>
								</van-uploader>
							</template>
						</van-field>
						<van-field
							:readonly='readOnly'
							v-model="parentName"
							label="姓名"
							maxlength="10"
							placeholder="请输入姓名"
							:clearable="true"
							input-align="right"
							error-message-align="right"
							:class="!checkedEdit?'familyArchives_cell':''"
						/>
						<van-field
							readonly
							:value="birthday"
							label="出生日期"
							maxlength="10"
							placeholder="请选择出生日期"
							:clearable="true"
							input-align="right"
							@click="selectBirth"
							:class="!checkedEdit?'familyArchives_cell':''"
						/>
						<van-field
              readonly
							v-model="age"
							label="年龄"
							type="digit"
							maxlength="3"
							placeholder="请输入年龄"
							:clearable="true"
							input-align="right"
						/>
						<van-field
							readonly
							v-model="phone"
							label="手机号"
							type="tel"
							maxlength="11"
							placeholder="请输入手机号"
							:clearable="true"
							input-align="right"
							name="phone"
						/>
						<van-field
							readonly
							clickable
							name="datetimePicker"
							:value="region"
							label="所在地"
							placeholder="请选择"
							input-align="right"
							@click="pickerArea"
							:class="!checkedEdit?'familyArchives_cell':''"
						>
							<template #button>
								<div v-if="!readOnly">
									<img src="../../assets/images/family-archives/triangle.png" alt="" class="triangle">
								</div>
							</template>
						</van-field>
            <van-field
              :readonly='readOnly'
              v-model="street"
              label="详细地址"
              placeholder="请输入详细地址"
              :clearable="true"
              input-align="right"
              :class="!checkedEdit?'familyArchives_cell':''"
            />
						<van-field
							:readonly='readOnly'
							v-model="profile"
							label="简介"
							placeholder="请输入简介"
							:clearable="true"
							input-align="right"
							:class="!checkedEdit?'familyArchives_cell':''"
						/>
					</van-form>
        </div>
      </div>
    </div>

		<!-- 省市 -->
    <van-popup v-model="pickerAreaShow" position="bottom">
      <van-area
        title="地域"
        :area-list="areaList"
        :columns-num="3"
        :value="showCode"
        @cancel="pickerAreaShow=false"
        @confirm='onAreaConfirm'
      />
    </van-popup>

    <!-- 出生日期 -->
    <van-popup v-model="showDate" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择出生日期"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="showDate=false"
        @confirm="onConfirmPick"
      />
    </van-popup>

  </div>
</template>

<script>
import { areaList } from '@vant/area-data';
import { _queryArchives,_saveArchives,_birthdayAndAgeAndSigns,_upload } from '../../api/family-archives';
import {verticalScreen} from '../../assets/js/vertical-screen';
import { encryptBy } from '@/assets/js/encryption';
import { ages } from '@/assets/js/util'
export default {
	name:'family-archives',
  data() {
    return {
			checkedEdit: true,
			readOnly:true,// 禁用输入框
			uploader: [],// 上传头像
			headImg:'',// 显示头像
			male:require('../../assets/images/family-archives/male.png'),//
			female:require('../../assets/images/family-archives/female.png'),//
			pickerAreaShow:false,// 显示城市选择器
			areaList,// 城市列表
			showCode:'',// 默认显示哪个地区code
			showDate:false,  //显示时间控件
      minDate: new Date(1900, 0, 1),// 最小日期
      maxDate: new Date(),// 最大日期
      currentDate: new Date(),// 当前日期
			region:'',//地区
			id:'',// id
			parentName:'',//家长名称
			phone:'',//手机号
			sex:'',// 性别
			birthday:'',// 生日
			age:'',//年龄
			idCard:'',//身份证
			province:'',//省
			city:'',//市
			county:'',//区
			profile:'',//简介
			pic:'',// 图片文件
			headImage:'',// 上传图片
      street:'',// 详细地址
    };
  },
	created(){
		this.queryArchives();
	},
	mounted() {
    	verticalScreen();
  	},
  methods: {
    // 返回
    onClickLeft() {
      this.$router.go(-1);
    },
		//切换是否可以编辑
    handeler(){
      this.checkedEdit=false;
			this.readOnly=false;
    },
		// 选择出生日期
		selectBirth(){
			if(this.readOnly){
        return false
      }
			this.showDate = true;
		},
		// 展示选择地域
    pickerArea(){
			if(this.readOnly){
        return false
      }
      this.pickerAreaShow=true;
    },
		// 选择地区
    onAreaConfirm(e){
			this.province = e[0].name;
			this.city = e[1].name;
			this.county = e[2].name;
			this.region = e[0].name +"-"+ e[1].name +"-"+ e[2].name;
			this.pickerAreaShow=false;
    },
		// 选择生日
		onConfirmPick(value){
			this.birthday = this.formatDate(value);
			this.age = ages(this.birthday);
			this.showDate = false;
    },
		//格式化日期
    formatDate(val) {
      var y = val.getFullYear();
      var m = val.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = val.getDate();
      d = d < 10 ? "0" + d : d;
      return y + "-" + m + "-" + d;
    },
		// 查询家长档案
		queryArchives(){
			_queryArchives().then((res)=>{
        if(res.code==200){
					localStorage.setItem("parentsInfor", encryptBy(JSON.stringify(res.data)));
					this.age = res.data.age
					this.birthday = res.data.birthday;
					this.city = res.data.city;
					this.county = res.data.county;
					this.id = res.data.id;
					this.parentName = res.data.parentName;
					this.phone = res.data.phone;
					this.profile = res.data.profile;
					this.province = res.data.province;
					this.street = res.data.street;
					if(this.province || this.city || this.county) {
						this.region = this.province +"-"+ this.city +"-"+ this.county;
					} else {
						this.region = ''
					}

					this.headImage = res.data.headImg;
					if (!res.data.headImg) {
						if (res.data.sex === 1) {
							this.headImg = this.male;
						}else {
							this.headImg = this.female;
						}
					}else {
						// this.headImg = 'http://172.16.12.229:9100/' + res.data.headImg;
						// this.headImg = 'http://' + location.host + '/' + res.data.headImg;
						this.headImg= res.data.headImg;
					}
        }else{
          this.$toast(res.message)
        }
      })
		},
		// 保存家长档案
		saveArchives(){
			let image;
			if (this.pic) {
				image = this.pic;
			}else {
				image = this.headImage;
			}
			_saveArchives({
				"id":this.id,
				"parentName":this.parentName,
				"headImg":image,
				"phone":this.phone,
				"birthday":this.birthday,
				"province":this.province,
				"city":this.city,
				"county":this.county,
				"profile":this.profile,
				"street":this.street,
			}).then((res)=>{
        if(res.code==200){
					this.$toast(res.message)
        }else{
          this.$toast(res.message)
        }
      })
		},
    // 保存
    saveHandle() {
			this.checkedEdit=true;
			this.readOnly=true;
			this.saveArchives();
		},
		// 提交
		onSubmit(values) {
    },
		// 图片限制
		onOversize(file) {
      this.$toast('图片大小不能超过10M');
    },
		//更换头像
    dataURLtoFile (dataurl, filename) { // 将base64转换为file文件
	  let arr = dataurl.split(',')
	  let mime = arr[0].match(/:(.*?);/)[1]
	  let bstr = atob(arr[1])
	  let n = bstr.length
	  let u8arr = new Uint8Array(n)
	  while (n--) {
		u8arr[n] = bstr.charCodeAt(n)
	  }
	  return new File([u8arr], filename, {type: mime})
	},
    //更换头像
    afterRead(file) {
	    if (file.file.size > 10240) {
			let canvas = document.createElement('canvas') // 创建Canvas对象(画布)
			let context = canvas.getContext('2d')
			let img = new Image()
			img.src = file.content // 指定图片的DataURL(图片的base64编码数据)
			img.onload = () => {
			  canvas.width = 400
			  canvas.height = 300
			  context.drawImage(img, 0, 0, 400, 300)
			  file.content = canvas.toDataURL(file.file.type, 0.92) // 0.92为默认压缩质量
			  let files = this.dataURLtoFile(file.content, file.file.name)
			  const data = new FormData()
			  data.append('file', files)
        _upload(data).then((res)=>{
          if(res.code =='200'){
            this.headImg=file.content;
						this.pic = res.data;
          }else{
            this.$toast("上传失败");
          }
        })
			}
		} else { //小于10M直接上传
			const data = new FormData()
			data.append('file',file.file)
			_upload(data).then((res)=>{
			  if(res.code =='200'){
			    this.headImg=file.content;
					this.pic = res.data;
			  }else{
			    this.$toast("上传失败");
			  }
			})
		}
    },
  },
};
</script>

<style lang="scss" scoped>
.cardioBg {
  width: 100%;
  height: 100%;
  background: #faf9fd url(../../assets/images/family-archives/background.png)
    left bottom;
  background-size: 100% auto;
  box-sizing: border-box;
  .mainBg {
    width: 90%;
    height: 90%;
    border-radius: 6px;
    margin: 10px auto 15px 4%;
    padding: 15px 0;
    position: relative;
    z-index: 2;
    .mainContent {
      width: 345px;
      height: 100%;
      background: #ffffff;
      box-shadow: 0px 1px 8px 0px #ffdfb6;
      border-radius: 6px;
      padding: 10px;
      .titBg {
        width: 100%;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        color: #333;
        font-weight: 600;
        div {
          margin: 0 25px;
        }
        img {
          width: 20px;
          display: inline-block;
        }
      }
    }
  }
	.basic{
		.title{
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 13px;
		}
		.title-group{
			margin-left: 10px;
			display: flex;
			align-items: center;
		}
		.title-img{
			width: 20px;
			height: 20px;
			margin-right: 8px;
		}
		.resord-cell{
			::v-deep .van-cell{
				padding:8px 25px 8px 0;
			}
		}
		.fristcell{
			height: 66px;
			::v-deep.maskLayer{
				border-radius: 30px;
			}
			img{
				width:40px;
				height: 40px;
			}
			::v-deep .van-field__label{
				display: flex;
				align-items: center;
			}
			::v-deep .van-image--round{
				width:40px;
				height: 40px;
			}
		}
		.familyArchives_cell {
			::v-deep .van-field__value {
				background-color:rgba(255,131,64,.07);
			}
		}
		::v-deep .van-field__value {
			padding-right: 5px;
		}
		.triangle{
			position: relative;
			top: 8px;
			width: 14px;
		}
		::v-deep .van-cell::after{
			display: none;
		}
	}
}
.margintop20{
  margin-top:20px;
}
</style>
